// extracted by mini-css-extract-plugin
module.exports = {"CloseBtn":"ReportModal_CloseBtn__AxMDv","SubmitBtn":"ReportModal_SubmitBtn__3LGd6","Description":"ReportModal_Description__sVBxk","Alert":"ReportModal_Alert__7QSk1"};